export default "__VITE_ASSET__e44069b0__"